require('./assets/scss/app.scss');
require('./assets/js/functions');
require('./assets/js/app');
require('./assets/js/swiped-events');
require('./assets/js/sliders');
